import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import { DataLoader } from "../DataLoader";

export const AppMainContent: React.FC<{ isMobile?: boolean }> = ({
  isMobile = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: "100vh",
        overflowY: "hidden",
        p: { xs: 1.5, md: 4 },
        mt: isMobile ? 6 : 0,
      }}
    >
      {isMobile && <Toolbar sx={{ minHeight: 0 }} />}
      <Box id="workarea" sx={{ overflow: "auto", flex: 1 }}>
        <DataLoader>
          <Outlet />
        </DataLoader>
      </Box>
    </Box>
  );
};
